export function validateBb(accountNumber, givenCheckDigit) {
    return calculateBbDigit(accountNumber.padStart(8, '0')) == givenCheckDigit;
}

function calculateBbDigit(contaComDV) {
  // Extrai apenas os números da conta
  const conta = contaComDV.replace(/\D/g, '');
  
  // Calcula o DV da conta
  const pesos = [9, 8, 7, 6, 5, 4, 3, 2];
  let soma = 0;
  for (let i = 0; i < pesos.length; i++) {
    soma += Number(conta.charAt(i)) * pesos[i];
  }
  const resto = soma % 11;
  const complemento = (resto === 0 || resto === 1) ? 0 : 11 - resto;
  const dvCalculado = complemento;
  
  // Verifica se os DVs são iguais
  return dvCalculado;
}